<template>
    <div class="full-container service">
        <apj-page-banner :options="options"></apj-page-banner>
        <div class="container introduce-container" style="padding-top: 50px; padding-bottom:50px;">
          <div class="title">ATP测试机器人</div>
          <div class="content">ATP(Automated Testing Platform)是APJ结合多年的测试服务经验研发出具有自主知识产权的仅填写Excel就可部署执行自动化测试的平台解决方案。平台的主要目标是解决自动化测试运用过程中的技术要求高、脚本维护难度大、灵活可靠性低等关键问题。ATP在2018年01月荣获了“高新技术产品”认证。</div>
        </div>
        <div class="full-container atp-flow-1">
          <img :src="img[0]" />
        </div>

        <div class="full-container atp-advantage">
          <div class="container introduce-container" style="padding-top: 50px; padding-bottom:50px;">
            <div class="title">简单易学、稳定高效、易维护、易扩展</div>
          </div>
          <div class="atp-items">
            <div class="atp-item" v-for="(item, index) in advantage" :key="'advantage' + index">
              <span class="atp-number">{{'0' + (index + 1)}}</span>
              <div class="atp-desc">{{item}}</div>
            </div>
          </div>
        </div>

        <div class="container introduce-container" style="padding-top: 50px; padding-bottom:50px;">
          <div class="title">应用场景</div>
          <div class="content">在测试工具基础上采用中间语言技术，做到不同的测试工具以及不同的测试目标系统使用相同的方法进行自动化开发。提供覆盖功能测试、兼容性测试、容错性测试、业务流程测试、稳定性测试、接口测试等在内的一站式自动化测试服务。</div>
        </div>
        <div class="full-container atp-flow-1">
          <img :src="img[1]" />
        </div>

        <div class="full-container atp-get" :style="{'background-image': 'url(' + getImg + ')'}">
          <div class="get-title">立即拥有属于您的ATP测试机器人</div>
          <div class="get-button">扫码获取方案</div>
          <el-image class="get-img" :src="contactQrImg" ></el-image>
        </div>

        <div class="atp-success">
          <div class="title">成功案例</div>
          <img :src="img[2]" />
        </div>
        <apj-page-contact></apj-page-contact>
    </div>  
</template>

<script>
import ApjPageContact from '@/components/apj-page-contact'
import ApjPageBanner from '@/components/apj-page-banner'
export default {
  name: "res",
  components: {
    ApjPageContact,
    ApjPageBanner,
  },
  data() {
    return {
      options: {
        banner: require('@/assets/site/programme_atp/banner.jpg'),
        title: "ATP测试机器人解决方案",
        text: ''
      },
      img: [
        require('@/assets/site/programme_atp/img_1.png'),
        require('@/assets/site/programme_atp/img_2.png'),
        require('@/assets/site/programme_atp/img_3.png')
      ],
      getImg: require('@/assets/site/contact_bg_higher.jpg'),
      contactQrImg: require('@/assets/site/dp_qr.png'),
      advantage: [
        "仅填写Excel即可完成测试部署,无需编写复杂的测试脚本",
        "引入中间语言技术，ATP使用者无需去学习多种不同的自动化测试工具及脚本技术",
        "提供各个行业的多种通用测试模型直接套用满足不同的测试需求",
        "独有的结构化错误处理机制，真正做到7*24小时无人值守",
        "支持Web、Desktop. Android、iOS全平台系统及跨平台环境下的软件产品测试"
      ]
    };
  },
  mounted() {
    // 进入页面时，菜单是否透明，或不显示阴影，默认为false，这里是示例
    globalEvent.$emit('changeHeaderTransparent', {
      isTransparent: true,
      isNoShadow: false
    })
    globalEvent.$emit('changeMenu', 3)
    // globalEvent.$emit('pageLoad')
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '@/assets/theme.scss';

div {
  width: 100%;
}

/** page style */
.atp-introduce {
  align-self: flex-start;
  max-width: 1250px;
}
.introduce-container {
  max-width: 1250px;
  padding: 80px;
}

.introduce-container-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}

.title {
  padding: 10px 0 30px;
  font-size: 30px;
  font-weight: bold;
}

.atp-flow-1 {
  padding: 0px 0 80px;
}
.atp-flow-2 {
  height: 550px;
  background-color: $color-bg-grey;
  padding: 0px 0 50px;
  img {
    background-color: $color-bg-white;
    border-radius: 10px;
    box-shadow: 2px 2px 10px #eeeeee;
    padding: 20px;
  }
}
.atp-flow-3 {
  padding: 350px 0 80px;
}

.atp-advantage {
  height: 550px;
  background-color: $color-bg-grey;
}

.atp-items {
  display: flex;
  justify-content: space-between;
  padding: 0 160px;
  
  .atp-item {
    min-height: 280px;
    padding: 15px;
    margin: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: $color-bg-white;
    border: 1px solid #dddddd;

    .atp-number {
      width: 40px;
      padding-bottom: 10px;
      margin-bottom: 30px;
      font-size: 30px;
      word-spacing: 10px;
      font-weight: bold;
      border-bottom: 3px solid $color-border-primary;
    }
  }
  .atp-item:hover {
    cursor: pointer;
    background-color: $color-bg-primary;
    .atp-number {
      color: $color-text-white;
      border-bottom: 3px solid $color-border-white;
    }
    .atp-desc {
      color: $color-text-white;
    }
  }
}

.atp-get {
  padding-top: 80px;
  margin-top: 50px;
  height: 650px;

  .get-title {
    font-size: 42px;
    line-height: 84px;

  }
  $buttonHeight: 40px;
  .get-button {
    width: 200px;
    height: $buttonHeight;
    border-radius: $buttonHeight;
    line-height: $buttonHeight;
    background-color: $color-bg-primary;
    color: $color-text-white;
  }
  .get-img {
    margin-top: $buttonHeight;
    width: 150px;
    height: 150px;
  }
}

.atp-success {
  width: 1200px;
  z-index: 10;
  margin-top: -200px;
  padding: 50px;
  background-color: $color-bg-white;
  border-radius: 10px;
  box-shadow: 2px 2px 10px #eeeeee;
}
</style>



// WEBPACK FOOTER //
// src/views/product/atp/index.vue